import React, { useState, useEffect } from 'react';
import UpgardeContent from '../../Shared/Subscription/UpgradeContent';
import { bindShuffleMessageI18nEvents, messages } from '../../Shared/ShuffleMessage/MessagesHelper';
import { FailurePublishContent } from '../../PublishToRuntime/FailurePublish';
import { SuccessfulPublishContent } from '../../PublishToRuntime/SuccessfulPublish';
import ShuffleMessage from '../../Shared/ShuffleMessage/ShuffleMessage';
import { sendEmailWithPostMark, POSTMARK_TEMPLATE_KEYS } from '../../../API/EmailApi';
import { useInvitation } from '../../../Context/Invitation/InvitationContext';
import { cloneMasterAppsToTenant } from '../../../API/Tenant/Tenant';


const PublishingAppForTenant = (props) => {
    const { state } = useInvitation();
    const invitation = state.invitations
    const invitedByUser = state.invitations.invitedByUser || {};
    const {
        user,
        organization,
        selectedApp,
        onCancel,
        onCreate,
        onCloneFailed
    } = props;
    const [appStatus, setAppStatus] = useState("");
    const [error, setError] = useState({ isValid: true, message: "" });

    useEffect(() => {
        const publishWorkflow = async () => {
            bindShuffleMessageI18nEvents();
            try {
                console.time("cloneTime")
                const response = await cloneMasterAppsToTenant(invitation._id, selectedApp._id, user.azureId);
                console.timeEnd("cloneTime")
                if (response.status === "success") {
                    setAppStatus("Success");
                    onCreate(response.data);
                } else {
                    if (response.type === "upgrade") {
                        setAppStatus("Upgrade");
                        return;
                    }
                    setAppStatus("Failure");
                    setError(response.error);
                    await sendCloneFailedEmail(response.error);
                }
            } catch (error) {
                setAppStatus("Failure");
                setError({ isValid: false, message: error.message });
            }
        };
        publishWorkflow();
    }, [selectedApp, organization]);

    const sendCloneFailedEmail = async (errorMessage) => {
        const emailTo = invitedByUser.email;
        let properties = {
            invited_name: invitedByUser.firstName || emailTo.split("@")[0],
            app_name: selectedApp.name,
            tenant_name: invitation.tenantName,
            error_message: errorMessage,
            product_name: process.env.REACT_APP_PRODUCT_NAME,
            company_address: process.env.REACT_APP_COMPANY_ADDRESS,
            product_url: process.env.REACT_APP_PRODUCT_URL,
            company_name: process.env.REACT_APP_COMPANY_NAME,
            subject: "Alert: App Cloning Failed in Your Tenant",
        }
        await sendEmailWithPostMark(emailTo, POSTMARK_TEMPLATE_KEYS.CLONE_FAILED, properties);
        onCloneFailed()
    }

    if (!error.isValid) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                <div className="alert alert-danger" role="alert">
                    {error.message}
                </div>
            </div>
        );
    }

    if (appStatus === "Upgrade") {
        return (
            <div className="d-flex justify-content-center align-items-center m-auto h-75">
                <UpgardeContent
                    onBack={onCancel}
                    Type={'Pro'}
                />
            </div>
        );
    }

    if (appStatus === "Success") {
        return (
            <SuccessfulPublishContent
                showButtons={false}
                isShowFromWorkspace={true}
                onBack={onCancel}
            />
        );
    }

    if (appStatus === "Failure") {
        return (
            <FailurePublishContent
                isShowFromWorkspace={false}
                showOkayButton={false}
                title={"App creation failed. Please try again later."}
                onClose={onCancel}
            />
        );
    }

    return (
        <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
            <div style={{ height: "80%" }}>
                <img
                    alt="loader-clone"
                    height={"100%"}
                    src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/library.gif`}
                />
            </div>
            <ShuffleMessage data={messages.cloneApp} interval={3000} />
        </div>
    );
};

export default PublishingAppForTenant;
